<template>
	<div id="app">
		<router-view v-if="isRouterAlive"></router-view>
		<!-- $route.meta.keepAlive == true 返回父级页面，页面不刷新 -->
		<!-- <keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view> -->
	</div>
</template>

<script>
	import * as util from '@/utils/network'
	import wx from "weixin-js-sdk";
	export default {
		provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
			return {
				reload: this.reload,
				bgColor: '#fff',
				textColor: '#000'
			}
		},
		data() {
			return {
				isRouterAlive: true //控制视图是否显示的变量
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false; //先关闭，
				// this.$store.commit('logOut');
				this.$nextTick(function() {
					this.isRouterAlive = true; //再打开
				})
			}
		},
		created() {
			//在页面加载时读取localStorage状态 复制对象是解决新vuex管理的状态中新添加的字段也可以存入localStorage中

			localStorage.getItem("Gconfig") && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(
				localStorage.getItem("Gconfig"))));

			//在页面刷新时将vuex里的信息保存到localStorage里，避免多次调用localStorage进行存储降低性能,beforeunload是在页面刷新之前调用

			window.addEventListener("beforeunload", () => {
				localStorage.setItem("Gconfig", JSON.stringify(this.$store.state))

			})
			// //在页面加载时读取localStorage里的状态信息
			// if (localStorage.getItem("Gconfig")) {
			// 	this.$store.replaceState(
			// 		Object.assign(this.$store.state, JSON.parse(localStorage.getItem("Gconfig")))
			// 	);
			// 	console.log('正在恢复$store')
			// 	console.log(this.$store.state)
			// }
			// //在页面刷新时将vuex里的信息保存到localStorage里
			// window.addEventListener("beforeunload", () => {
			// 	console.log('刷新前：',JSON.stringify(this.$store.state))
			// 	localStorage.setItem("Gconfig", JSON.stringify(this.$store.state))
			// })

			var url = "/addons/litestore/api.wxapp/base"
			let that = this;

			//这里直接调用网络接口
			util.get(url, {},
				function(result) {
					that.$store.commit('setCFG', result['data']['wxapp'])
				},
			);
		},

	}
</script>

<style lang="less">
	* {
		margin: 0;
		padding: 0;
		touch-action: pan-y;
	}
  .ell {
    white-space: nowrap;
    overflow: hidden;
  }
	.ells {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.leopages {
		background-color: rgb(232, 232, 232, .2);
	}

	.ells2 {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.ells4 {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		line-clamp: 4;
		-webkit-box-orient: vertical;
	}
	.ells5 {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		line-clamp: 5;
		-webkit-box-orient: vertical;
	}

	img {
		/*width: 100%;*/
		height: 100%;
	}

	body {
		font-size: 16px;
		background-color: #fff;
		-webkit-font-smoothing: antialiased;
		height: 100%;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		margin-bottom: 50px;
	}

	.van-grid-item .van-grid-item__text {
		color: #000;
		margin-top: 5px;
	}

	.leoloading {
		background-color: transparent !important;
		color: #c8c9cc !important;
		font-size: 13px;

		.van-toast__loading {
			color: #000000;
		}
	}
</style>
